import { lovetConsts } from '@shared-components/constants';

interface IClickContext {
	brand?: string;
	type?: string;
}

export const clickContext = ({ brand, type }: IClickContext) => {
	if (brand === 'Lovet' && type === 'scheduleClick') {
		return {
			...lovetConsts.context,
			...lovetConsts[type as keyof typeof lovetConsts],
		};
	}

	return null;
};
